var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div flex=\"40\" flex-offset=\"30\" ng-controller=\"tmLoginCtrl as vm\"><div class=\"row\"><div class=\"well\"><h1>Login</h1><p>Enter username and password.  If you are not a paying member sign up here.</p><div class=\"form\"><div class=\"form-group\"><input placeholder=\"Email\" ng-model=\"vm.username\" class=\"form-control\"/></div><div class=\"form-group\"><input type=\"password\" placeholder=\"Password\" ng-model=\"vm.password\" class=\"form-control\"/></div><div class=\"form-group\"><input type=\"checkbox\" name=\"remember\" ng-model=\"vm.remember\"/>&nbsp; Remember Me</div><button ng-click=\"vm.signin(vm.username, vm.password,vm.remember)\" class=\"btn btn-primary\">Sign In</button></div></div></div><div class=\"row\"><a ui-sref=\"root.signup\" class=\"pull-right\">Signup</a></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/shell/account/login.jade
// module id = 156
// module chunks = 0